module.exports = __webpack_public_path__ + "static/img/Leclerc.9d5d764.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Leclerc.jpg
// module id = gfUQ
// module chunks = 1